// extracted by mini-css-extract-plugin
export default {"item":"SideItem_item__dePpC","itemSelected":"SideItem_itemSelected__HzpMf"};